export default __webpack_public_path__ + "static/ro-4bf99607b77ec3a45315b829a2557a9d.svg";